export enum DeductionType {
    Door = 1,
    Window,
    Cabinet,
    Closet,
    Other
}